<!-- 获取停车场实时数据接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KNTYVWC"
            },
            responseCode: {
                "data": {
                    "totalCarports":"100",
                    "eptCarports":"11",
                    "enterTimes":"11",
                    "outerTimes":"11",
                    "totalParkCharge":"100.00"
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取停车场实时数据",
                t_url: this.commonUrls.test+"getRealTimeParkInfo",
                p_url: this.commonUrls.prod+"getRealTimeParkInfo",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'totalCarports', info2: '是', info3: 'Integer', info4: '总车位数' },
                        { info1: 'eptCarports', info2: '是', info3: 'Integer', info4: '空车位数' },
                        { info1: 'enterTimes', info2: '是', info3: 'Integer', info4: '当日进场总数' },
                        { info1: 'outerTimes', info2: '是', info3: 'Integer', info4: '当日离场总数' },
                        { info1: 'totalParkCharge', info2: '是', info3: 'Decimal', info4: '当日停车收费总费用' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/dataAnalysis/getRealTimeParkInfo.vue